import React, { useEffect, useRef, useState } from 'react';
import { icons } from '~/assets';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import Loading from '~/components/loading';
import RadioButton from '~/components/radioButton';
import useApi, { ApiMethod } from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';
import BankReturnUpload from './components/BankReturn';
import ZeussFileUpload from './components/Zeuss';
import * as St from './styles';

interface IFiles {
  id: number;
  name: string;
  content: string;
}
interface IResponse {
  mensagem?: string;
  filename?: string;
  processamento?: string;
  baixasTotal?: string;
  baixasCobranca?: string;
  baixasAutorizador?: string;
}

const FileUpload: React.FC = () => {
  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalFailure, setModalFailure] = useState(false);
  const [items, setItems] = useState<IFiles[]>([]);
  const [conciliaData, setConciliaData] = useState<IResponse>({});
  const [menssagem, setMenssagem] = useState('');
  const [openFeed, setOpenFeed] = useState(false);
  const [openFeedConcilia, setOpenFeedConcilia] = useState(false);

  const apiUpload = useApi(Endpoints.files.upload, ApiMethod.PUT);

  const apiConciliarArquivo = useApi<IResponse>(
    Endpoints.consult.conciliarArquivo,
    ApiMethod.GET,
  );

  useEffect(() => {
    if (apiUpload.status) {
      modalDisplay();
    }
  }, [apiUpload.status]);

  const inputFileRef = useRef(null);
  const TypeUploadButton = ({ type, icon, label }) => {
    return (
      <St.ButtonSelectTypeUpload
        selected={selectedItem === type}
        onClick={() => setSelectedItem(type)}
      >
        <div className="radio-container">
          <RadioButton checked={selectedItem === type} />
        </div>
        <div className="img-container">
          <img src={icon} />
        </div>
        <span>{label}</span>
      </St.ButtonSelectTypeUpload>
    );
  };
  const fileToBase64 = async (f) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (e) => reject(e);
    });

  const fileSelected = async (e) => {
    const fileValue = e.target.files[0];

    if (fileValue) {
      const { name } = fileValue;
      const base64 = (await fileToBase64(fileValue)) as string;

      const newFile = { id: Math.random() / 2, name, content: base64 };

      setItems((prev) => [...prev, newFile]);
    }
  };

  const deleteItem = (id) => {
    const newItems = [];

    items.forEach((i) => {
      if (i.id !== id) newItems.push(i);
    });

    setItems(newItems);
  };

  const triggerFilePicker = () => inputFileRef.current.click();

  const send = async () => {
    await Promise.all(
      items.map((i) => {
        if (modalFailure) return;

        const payload = {
          arquivo: i.content.split(',')[1],
          nomeArquivo: i.name,
        };

        return apiUpload.callApi(payload);
      }),
    );

    setItems([]);
  };

  async function handleClickProcessar() {
    const response = await apiConciliarArquivo.callApi();

    const data = response.data as IResponse;

    if (data[0]) {
      setConciliaData({
        baixasTotal: data[0].baixasTotal,
        baixasAutorizador: data[0].baixasAutorizador,
        baixasCobranca: data[0].baixasCobranca,
        filename: data[0].filename,
        processamento: data[0].processamento,
      });
      setOpenFeedConcilia(true);
    } else {
      setMenssagem('Não há linhas a ser processadas!');
      setOpenFeed(true);
    }
  }

  const modalDisplay = () => {
    if (apiUpload.status === 200) {
      setModalFailure(false);
      setModalSuccess(true);
    } else {
      setModalSuccess(false);
      setModalFailure(true);
    }
  };
  const [selectedItem, setSelectedItem] = useState('');
  return (
    <>
      <St.InputFileHidden
        ref={inputFileRef}
        type="file"
        onChange={fileSelected}
      />

      <Dialog
        open={modalSuccess}
        message="Arquivos enviados com sucesso"
        positiveAction={() => setModalSuccess(false)}
        positiveLabel="Fechar"
      />

      <Dialog
        open={modalFailure}
        message="Erro ao enviar os arquivos"
        positiveAction={() => setModalFailure(false)}
        positiveLabel="Fechar"
      />

      <Dialog
        open={openFeed}
        message={menssagem}
        positiveAction={() => setOpenFeed(false)}
        positiveLabel="Fechar"
      />

      <Dialog
        open={openFeedConcilia}
        positiveAction={() => setOpenFeedConcilia(false)}
        positiveLabel="Fechar"
      >
        <span>{`Linhas processadas: ${conciliaData.baixasTotal}`}</span>
        <span>{`Linhas baixadas: ${conciliaData.baixasCobranca}`}</span>
        <span>
          {`Linhas baixadas no autorizador: ${conciliaData.baixasAutorizador}`}
        </span>
      </Dialog>

      <Loading status={apiConciliarArquivo.loading || apiUpload.loading} />

      <Container>
        <St.BoxCard>
          <ContainerFlex row gap={'16'} horizontal>
            <TypeUploadButton
              label="Zeuss"
              type="zeuss"
              icon={icons.iconZeuss}
            />
            <TypeUploadButton
              label="Arquivo retorno bancário"
              type="bancario"
              icon={icons.iconUploadBancario}
            />
          </ContainerFlex>

          {selectedItem === 'bancario' ? <BankReturnUpload /> : null}
          {selectedItem === 'zeuss' ? <ZeussFileUpload /> : null}
        </St.BoxCard>
      </Container>
    </>
  );
};

export default FileUpload;
